import React, { useState, useEffect } from 'react';

function LapDaily() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);  
  const [searchQuery, setSearchQuery] = useState(''); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const schema = localStorage.getItem('schema');

  const today = new Date();
  const last30Days = new Date(today);
  last30Days.setDate(today.getDate() + 30);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    return date.toISOString().split('T')[0];
  };

  const formatNumber = (value) => {
    if (isNaN(value)) return value;
    return new Intl.NumberFormat('id-ID', { minimumFractionDigits: 0 }).format(Number(value));
  };


  const [end_date, setEndDate] = useState(formatDate(today));

  const [filters, setFilters] = useState({
    NO_TRANSAKSI: '',
    NAMAREKANAN: '',
    JNS_MUATAN: '',
    JNS_KENDARAAN: '',
    NOPOL: '',
    SOPIR: '',
    KOTA_ASAL: '',
    KOTA_TUJUAN: '',
    TOTAL: '',
  });

  const fetchLapPasangData = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!end_date) {
        throw new Error('Tanggal akhir harus diisi');
      }

      const url = `${process.env.REACT_APP_API_BASE_URL}/laporan.php?caller=daily_do&schema=${schema}&end_date=${end_date}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Invalid data format from API');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (end_date) {
      fetchLapPasangData();
    }
  }, [end_date]);

  useEffect(() => {
    applyFilters();
  }, [filters, LapPasangData]);

  const applyFilters = () => {
    let filtered = LapPasangData.filter((item) => 
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key]).toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleColumnFilter = (e, key) => {
    setFilters({ ...filters, [key]: e.target.value });
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

const kirimemail = async () => {
  if (!end_date) {
    alert('Tanggal akhir belum dipilih');
    return;
  }

  try {
    const url = schema.toUpperCase() === "KMT"
    ? `${process.env.REACT_APP_API_BASE_URL}/kirim_email_kmt.php?end_date=${end_date}`
    : `${process.env.REACT_APP_API_BASE_URL}/kirim_email_kit.php?end_date=${end_date}`;

    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('Gagal mengirim email');
    }

    const text = await response.text();

    if (text.includes('Sukses')) {
      alert('Email berhasil dikirim');
    } else {
      alert('Email terkirim tapi tidak ada respon sukses');
    }
  } catch (error) {
    alert('Terjadi kesalahan saat mengirim email: ' + error.message);
  }
};


  return (
    <div style={{ padding: '20px', backgroundColor: '#f9f9f9' }}>
      <h2 style={{ color: '#9B459C' }}>Laporan Harian</h2>
      <div>
        <label>Periode: </label>
        <input type="date" value={end_date} style={{ marginLeft: '20px' }} onChange={(e) => setEndDate(e.target.value)} />
        <button onClick={fetchLapPasangData} style={{ marginLeft: '10px' }}>Refresh</button>
        <button onClick={kirimemail} style={{ marginLeft: '10px' }}>Email</button>
      </div>


      <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: '20px' }}>
        <thead>
          <tr> 
              <th onClick={() => handleSort('NO_TRANSAKSI')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                NO DO{getSortIcon('NO_TRANSAKSI')}
              </th>                  
              <th onClick={() => handleSort('NAMAREKANAN')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                REKANAN {getSortIcon('NAMAREKANAN')}
              </th>                  
              <th onClick={() => handleSort('JNS_MUATAN')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                JNS MUATAN {getSortIcon('JNS_MUATAN')}
              </th>    
              <th onClick={() => handleSort('JNS_KENDARAAN')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                JNS KENDARAAN {getSortIcon('JNS_KENDARAAN')}
              </th>    
              <th onClick={() => handleSort('NOPOL')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                NOPOL {getSortIcon('NOPOL')}
              </th>                
              <th onClick={() => handleSort('SOPIR')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                SOPIR {getSortIcon('SOPIR')}
              </th>                                              
              <th onClick={() => handleSort('KOTA_ASAL')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                KOTA ASAL {getSortIcon('KOTA_ASAL')}
              </th>                                              
              <th onClick={() => handleSort('KOTA_TUJUAN')} style={{ cursor: 'pointer', width: '100px', border: '1px solid #ddd', padding: '8px' }}>
                KOTA TUJUAN {getSortIcon('KOTA_TUJUAN')}
              </th>                                              
              <th onClick={() => handleSort('TOTAL')} style={{ cursor: 'pointer', width: '60px', border: '1px solid #ddd', padding: '8px' }}>
                TOTAL{getSortIcon('TOTAL')}
              </th>                                      
          </tr>

          <tr>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'NO_TRANSAKSI')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'NAMAREKANAN')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'JNS_MUATAN')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'JNS_KENDARAAN')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'NOPOL')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'SOPIR')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'KOTA_ASAL')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'KOTA_TUJUAN')} placeholder="Filter..." /></th>
              <th><input style={{ border: '1px solid #ddd', padding: '8px', width: '80%', }} type="text" onChange={(e) => handleColumnFilter(e, 'TOTAL')} placeholder="Filter..." /></th>
          </tr>    
        </thead>
        <tbody>
          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <tr key={item.ID}>
                {['NO_TRANSAKSI', 'NAMAREKANAN', 'JNS_MUATAN', 'JNS_KENDARAAN','NOPOL','SOPIR','KOTA_ASAL','KOTA_TUJUAN', 'TOTAL'].map((key) => (
                  <td
                    key={key}
                    style={{
                      border: '1px solid #ddd',
                      padding: '8px',
                      textAlign: key === 'TOTAL' ? 'right' : 'left'
                    }}
                  >
                    {key === 'TOTAL' ? formatNumber(item[key]) : item[key]}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" style={{ textAlign: 'center', padding: '10px' }}>Tidak ada data</td>
            </tr>
          )}
        </tbody>

      </table>
    </div>
  );
}

export default LapDaily;
